import { Component, OnInit, HostListener } from '@angular/core';
import { ScrollService } from '../services/scroll.service';

@Component({
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss']
})
export class ScrollToTopComponent implements OnInit {
  showScrollButton = false;

  constructor(private scrollService: ScrollService) { }

  ngOnInit(): void {
    this.checkScrollPosition();
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.checkScrollPosition();
  }

  private checkScrollPosition(): void {
    this.showScrollButton = this.scrollService.hasScrolled();
  }

  scrollToTop(): void {
    this.scrollService.scrollToTop();
  }
} 